document.addEventListener('DOMContentLoaded', (event) => {
  const atcButton = document.querySelector('.button-subscription-atc');
  const buttonPrice = document.querySelector('.button-subscription-atc .price-btn');
  const subs_details = document.querySelector('.subs_details');
  const tab_subs_details = document.querySelector('#subscription_details details');
  const variants = Array.from(document.querySelectorAll('.variant-selector input'));
  let btnWrapper = document.querySelector('.sticky-atc__button');
  const url = window.location.href;
  let clonedBtn = atcButton.cloneNode(true);
  clonedBtn.classList.add('cloned-atc');

  const stickyElem = document.querySelector('.sticky-atc');

  cartNotification = document.querySelector('cart-notification');
      // custom ATC fucntion 

  const customATCFuncion = function(event) {
    let sellingPlan = this.dataset.sellingPlan;
    let prodId = this.dataset.product;
    let data = {}
    cartNotification.setActiveElement(document.activeElement);

    if(sellingPlan != ''){
    data = {
      id: parseInt(prodId),
      quantity: 1,
      selling_plan: parseInt(sellingPlan),
      sections: cartNotification.getSectionsToRender().map((section) => section.id)
    }
    }else {
    data = {
        id: parseInt(prodId),
        quantity: 1,
        sections: cartNotification.getSectionsToRender().map((section) => section.id)
      }
    }

   

    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(data)
    })
    .then((response) => response.json())
    .then(response => {
     
      let haveFixed = false;
      document.querySelector("#cart-notification-form button").addEventListener("click", function(evt) {
        if(haveFixed == true) { return; }
        evt.preventDefault();
        window.onwardApp.fixInsuranceAndProceed().then(() => {
          haveFixed = true;
          const event = new MouseEvent('click', { view: window, bubbles: true, cancelable: true});
          evt.target.dispatchEvent(event);
        });
      });
     
      return response.json();
     
    }).catch((error) => {
      console.error('Error:', error);
    }).finally(() => {
       window.onwardApp.fixInsuranceAndProceed().then(() => {
         window.location.href = '/checkout';
       });
    });
  }

    atcButton.addEventListener('click', customATCFuncion);
    clonedBtn.addEventListener('click', customATCFuncion);
     
  // Sticky ATC 
  if(url.includes('/products')) {      
     btnWrapper.appendChild(clonedBtn);
     document.querySelector('.sticky-atc__button button').innerText = 'ADD TO CART'
      
    
      
     
      window.addEventListener('scroll', () => {
        let scroll = this.scrollY;
        let atcPos = atcButton.offsetTop - 500;
        
        if(scroll > atcPos) {
          stickyElem.classList.add('visible-btn')
        } else {
          stickyElem.classList.remove('visible-btn')
        }
      })
   }
 // update ATC Button 
  variants.map((variant) => {
    
      variant.addEventListener('change', function(){
        
         let thisPlan = this.dataset.sellingPlanId
         let thisProdId = this.dataset.productId;
         let thisPrice = this.dataset.price;
         let numericPrice = parseInt(this.dataset.price.replace("$", "").replace(".", ""));
         
         
          atcButton.dataset.sellingPlan =  thisPlan;
          atcButton.dataset.product = thisProdId;
          buttonPrice.innerText = thisPrice;

        // let cartVariant = window.onwardClient?.cartCalculator()?.findVariant(numericPrice);
        // if(cartVariant) {
        //   window.onwardApp.assignInsurancePrice(cartVariant);
        // }
        // sticky atc clone
        if(btnWrapper) {
          
          let clonedBtn = atcButton.cloneNode(true);
         
          clonedBtn.classList.add('cloned-atc');
          clonedBtn.addEventListener('click', customATCFuncion);
           btnWrapper.innerHTML = ''
           btnWrapper.appendChild(clonedBtn);
           document.querySelector('.sticky-atc__button button').innerText = 'ADD TO CART'
        }
      
      })
  });



})
